import { useField } from 'formik';
import React, { FC, ReactNode } from 'react';
import FieldControl from '../field-control/field-control';
import FieldUpload from '../field-upload/field-upload';

interface FormUploadProps {
  extensions?: string[];
  help?: string;
  label?: string;
  labelColor?: string;
  name: string;
  required?: boolean;
  tooltipComponent?: ReactNode;
  upload: (file: File) => unknown;
}

const FormUpload: FC<FormUploadProps> = ({
  extensions,
  help,
  label,
  labelColor,
  name,
  required,
  tooltipComponent,
  upload,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(name);

  return (
    <FieldControl
      required={required}
      label={label}
      error={meta.touched && !!meta.error ? meta.error : null}
      tooltipComponent={tooltipComponent}
      labelColor={labelColor}
    >
      <FieldUpload
        error={meta.touched && !!meta.error}
        extensions={extensions}
        help={help}
        onChange={(value) => helpers.setValue(value)}
        upload={upload}
      />
    </FieldControl>
  );
};

FormUpload.defaultProps = {
  extensions: null,
  help: null,
  label: null,
  labelColor: 'black',
  required: false,
  tooltipComponent: null,
};

export default FormUpload;
